import React from 'react';

/**
 * Cockpit Avatar — initials on rust, or an image. Optional presence dot.
 */
export interface AvatarProps {
  name?: string;
  src?: string | null;
  size?: number;
  presence?: 'online' | 'offline';
  style?: React.CSSProperties;
}

export default function Avatar({ name = '', src, size = 32, presence, style }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <span
      className="ck-avatar"
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: 'var(--radius-pill)',
        background: src ? 'var(--surface-raised)' : 'var(--accent)',
        color: 'var(--text-on-accent)',
        fontFamily: 'var(--font-mono)',
        fontSize: Math.round(size * 0.34),
        fontWeight: 'var(--weight-semibold)' as React.CSSProperties['fontWeight'],
        letterSpacing: '0.03em',
        border: '1px solid var(--border-hairline)',
        overflow: 'visible',
        flexShrink: 0,
        ...style,
      }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          style={{ width: '100%', height: '100%', borderRadius: 'var(--radius-pill)', objectFit: 'cover' }}
        />
      ) : (
        initials || '?'
      )}
      {presence ? (
        <span
          style={{
            position: 'absolute',
            bottom: '-1px',
            right: '-1px',
            width: Math.max(8, size * 0.28),
            height: Math.max(8, size * 0.28),
            borderRadius: 'var(--radius-pill)',
            background: presence === 'online' ? 'var(--status-up)' : 'var(--status-idle)',
            border: '2px solid var(--surface-canvas)',
          }}
        />
      ) : null}
    </span>
  );
}
